<template>
  <div class="BomsProjectTableComponent DataTables">
    <p v-if="selectedRevisionRow.length == 0">{{ lang.infotext_1 }}</p>
    <span v-show="selectedRevisionRow.length > 0">
      <p>{{lang.infotext_2}}:</p>
      <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>
      <ContextMenuComponent :menu="menu"  :id="name"></ContextMenuComponent>
    </span>
  </div>
  
    
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import ContextMenuComponent from "@/components/shared/ContextMenuComponent"
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'BomsProjectTableComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent,
    ContextMenuComponent

  },
  data () {
      return {
        name: 'BomsProjectTableComponent',
        mainTable: "",
        id: "tableplace_"+this._uid,
        columns: [],
        colsAssign: [],
        boms: [],
        variants: [],
        isData: false,
        contextMenu: {},
        //list of items in the context menu
        menu: [
        //   {id: "Open", text: this.lang.contextmenu_text_Open},
        //   {id: "NewRevision", text: this.lang.contextmenu_text_NewRevision},
        //   {id: "Delete", text: this.lang.contextmenu_text_Delete},
        ],

      }
  },
  computed: {
      

    revisionId(){
        
      if (this.$store.getters.selectedRevisionRow[0] == undefined) {
          
          return this.$route.query.revisionId;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId;
    },
    categoryId(){
        return this.$store.getters.selectedTreeProjectItemObject.categoryId;
    },
    reloadedAfterActionComplex(){
        return this.$store.getters.reloadedAfterActionComplex;
    },
    bomsProjectLength() {

      return this.boms.length;

    },
    selectedRevisionRow() {
      return this.$store.getters.selectedRevisionRow;
    }
  },
  created () {

    this.createBomsTable();


  },
  watch: {
    revisionId: function (newVal, oldVal) {

      
      this.createBomsTable();

    }, 
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.createBomsTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    
    boms: function (newValue, oldValue) {
      
      let value = this.boms.length > 0;
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_isBom", value);
    },
    bomsProjectLength: function (newValue, oldValue) {

      this.$parent.$parent.$parent.$parent.$parent.$parent.setBomsProjectLength(newValue);
      
    }
    
  },
  updated() {



  },
  mounted: function () {

  },
  methods: {
    createBomsTable() {
      
 
      if (this.revisionId != undefined){
        let vue = this;

        const obj = {
            projectRevisionId: this.revisionId
        }  
        
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBoms", obj)
        .then((result) => {
          console.log(result)
          if (result.status == "OK"){

            this.boms = result.data;
            vue.isData = true;  

            //to delete
            // for (let i = 0, lei = result.data.length; i < lei; i++){
            //   result.data[i].bomNumber = "A123"
            // }
            //to deletete
            
            vue.getVariants();
            


          }else{
              vue.isData = false;  
          }


        })
      } 
      
    },
    getVariants() {
      
      if (this.revisionId != undefined) {
        let vue = this;
        
        const obj = {
          projectRevisionId: this.revisionId
        }

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getVariants", obj)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {

              this.variants = result.data;
              


              vue.mapBomsAndVariants()



            } 


          })
      } 

      
    },
    mapBomsAndVariants() {

      for (let i = 0, lei = this.boms.length; i < lei; i++){
        this.boms[i].fileList = [];
        for (let j = 0, lej = this.variants.length; j < lej; j++) {

          if (this.boms[i].name == this.variants[j].name) {
            this.boms[i].fileList = this.variants[j].fileList;
          }

        }
      }



      this.buildColumns();
    },
    buildColumns(){
      

      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_BomNumber,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Description,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_When,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Who,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Files,
          alignInColumn: "left",
          type: "text"
        },
      ]

      this.colsAssign =  [
        { "data": "bomId" },
        { "data": "name" },
        { "data": "bomNumber" },
        { "data": "description" },
        { "data": "creationDate" },
        { "data": "login" },
        { "data": "bomId" },
        
      ]

      this.buildTable();
    },
    buildTable(){

      
      
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedBomRow");

      var tableplace = document.getElementById(this.id);
      
      if (tableplace == null) {
        
        return
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "place" + this._uid);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++){

        var el = {};

        var classname = '_dt-body-'+ this.columns[i].alignInColumn;

        el = {
          targets: i,
          className: classname,

          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 1) {
              if (row.isCore == true) {
                return data + " (core)";
              }
              return data;
            }
            if (meta.col == 4){
                return Tools.longDateToShort(data);
            }
            if (meta.col == 6) {

              let str = "";
              str += "<table class=\"file-table\">";
              for (let i = 0, lei = row.fileList.length; i < lei; i++) {
                str += "<tr class=\"file-tr\">"
                
                if (row.fileList[i].fileName != null) {
                  str += "<td class=\"table_w1\">"
                  let file = row.fileList[i];

                  let src = Tools.filenameToIcon(file.fileName);
                  str += "<a id=\"download_^_" + file.fileId + "_^_" + file.fileName + "_^_" + _vue.revisionId + "\" class=\"button-action-download\" href=\"#\"><img width=16px src=\"" + src + "\"> ";
                  str += file.fileName + "</a></td><td class=\"table_w2\">" + file.size + "</td><td class=\"table_w3\">" + Tools.longDateToShort(file.modificationDate) + "   <br>";
                  str += "</td>";
                }
                
                str += "</tr>"
              }

              str += "</table>";
              return str;
              
            }

            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        var br = document.createElement("br");
        th.appendChild(br);

        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }


      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fr<t>ip>';
      option.data= this.boms;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[1, "asc"]];
      option.lengthMenu = [[20]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {


        
      }
      option.fnDrawCallback = function( oSettings ) {
    
        //_vue.buildContextMenu();
      }


      if ($.fn.dataTable.isDataTable("#place"+this._uid)) {
          this.mainTable.destroy();
          
      }

      var _vue = this;

      this.mainTable = $('#place'+this._uid).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column( 0 ).visible( false );

      let _mainTable = this.mainTable;

      this.mainTable
        .on( 'select', function ( e, dt, type, indexes ) {

          var rowData = _mainTable.rows( indexes ).data();
          

          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedBomRow", rowData[0])

          _vue.getBomToIPC(rowData[0]);

        })
        .on( 'deselect', function ( e, dt, type, indexes ) {
          
          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedBomRow");
          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
        })

        $('#place'+this._uid+' tbody').on('dblclick', 'tr', function (e, dt, type, indexes) {
          e.stopPropagation() 
                        
          var data = _mainTable.row( this ).data();
          
          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedBomRow", data)
        
        
          _vue.$parent.$parent.$parent.$parent.$parent.$parent.openBom();
        } );

      //search input change view
      var searchplace = document.getElementById("place"+this._uid + "_filter").firstChild
      
      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


      let download_buttons = document.getElementsByClassName('button-action-download');

      for (let i = 0, lei = download_buttons.length; i < lei; i++) {
        download_buttons[i].addEventListener('click', function (e) {
          let id = this.id;
          let temp = id.split("_^_");


          const obj = {
            documentId: temp[1],
            revisionId: temp[3]

          }
          

          _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_downloadFile", obj)
            .then((result) => {


              console.log(result)
              let fileName = temp[2];

              var a = document.createElement("a");
              a.href = URL.createObjectURL(result);
              a.download = fileName;

              document.body.appendChild(a);

              a.click();
              document.body.removeChild(a);
            })
        })
      }  

    },
    buildContextMenu(){
      

      var _vue = this;

      
      //context-menu
      var tableid = $("#place" + this._uid);

      $("#place" + this._uid + " tbody tr")
      .on("contextmenu", function(e) {
        
        let tr = $(this).closest('tr');
        let row = _vue.mainTable.row( tr );

        let data = row.data();

        _vue.contextMenu.row = data

        

        //methods in table component
        //var updateUser = _vue.updateUser;
        //var deleteUser = _vue.deleteUser;

        _vue.contextMenu.funcAction = function(_vue, action){

          //calling component methods depending on the context menu item clicked
          if (action == "Open"){
            
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.open();
          }
          if (action == "NewRevision"){
            
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
              _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data);
              _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent.newRevision();
          }
          if (action == "Delete"){
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", data);
            _vue.$parent.$parent.$parent.$parent.$parent.$parent.$parent._delete();
          }
            

          return true;
        }

        var height = tableid.height();

        var offsetX = tableid.offset().left;
        var offsetY = tableid.offset().top;


        var top = e.clientY - offsetY + 100;
        var left = e.clientX - offsetX + 10;

        
        $("#context-menu-"+_vue.name).css({
          display: "block",
          top: top,
          left: left
        });
        return false; //blocks default Webbrowser right click menu
      })
      .on("click", function() {
        
        $("context-menu-"+_vue.name).hide();
      });

      $("#context-menu-"+_vue.name + " a").on("click", function() {
        
        $(this)
          .parent()
          .hide();
      });
      document.addEventListener('click', function(e){
        let clickInside = e.target.closest("#context-menu-"+_vue.name);
        
        if(clickInside == null){
          
          let contextMenu = document.getElementById("context-menu-"+_vue.name);
          if (contextMenu != null){

            contextMenu.setAttribute('style', 'display:none');
          }
          
                              
        }
      });
      //context-menu
    },
    getBomToIPC(data) {
      

      let vue = this;

      let obj = {
        bomId: data.bomId
      }
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getBom", obj)
        .then((result) => {
          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {
              let parts = result.data.parts;
              let referenceNumbers = [];
              for (let i = 0, lei = parts.length; i < lei; i++) {


                referenceNumbers.push(parts[i].PartReference);
              }

              data.partReference = referenceNumbers;

              let obj = {
                partReference: referenceNumbers
              }
              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_setSelectedPartBomRow", obj);
            }
          }
          
      })

      
    }
        
  }
}
</script>


<style lang="scss">
.BomsProjectTableComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .badge{
      margin-right: 1px;
      margin-top: 2px;
      margin-bottom: 2px;
    }
    .file-table {
      width: 100%;
      border-style: hidden;
      
    }

    .file-tr {
      border-style: hidden;
      
    }
    .file-td {
      
    }
    .table_w1 {
      width: 50%;
    }
    .table_w2 {
      width: 20%;
    }
    .table_w3 {
      width: 30%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BomsProjectTableComponent.vue